import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App.tsx";
import "katex/dist/katex.min.css";
import "./theme/globals.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

const savedTheme = JSON.parse(localStorage.getItem("lever-ui") || "{}")?.state?.theme || "dark";
document.documentElement.setAttribute("data-theme", savedTheme);

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Service worker registration is non-critical
    });
  });
}
